<template>
  <div>
    <PublicPageList v-if="list.length" :list="list" />
    <h5 v-else style="margin-top: 1rem; margin-bottom: 1rem">プロジェクトが見つかりませんでした</h5>
  </div>
</template>
<script lang="ts">
import { Vue, Options } from 'vue-class-component';
import RootVue from "@/RootVue.vue";
import PublicPageList from "@/component/publicPageList/PublicPageList.vue";
import PublicPageResp from '@/interface/api/PublicPageResp';

@Options({
  components:{
    PublicPageList
  },
  props:{
    list:{
      type: Array
    }
  }
})
export default class extends Vue {
  // @ts-expect-error
  $root: RootVue;
  readonly list!:PublicPageResp[]
}
</script>